import { Outlet } from "react-router-dom"

const SeasonPage = () => {
    return <Outlet />;
}

export default SeasonPage;
